import api from './api';

export interface CaseActivity {
  id: number;
  case_id: number;
  activity_type: 'note' | 'action' | 'document' | 'communication' | 'hearing' | 'stage_change' | 'other';
  title: string;
  description?: string;
  activity_date: string;
  created_by: number;
  created_by_name?: string;
  created_at?: string;
  updated_at?: string;
}

export interface CreateActivityDto {
  activity_type?: string;
  title: string;
  description?: string;
  activity_date: string;
}

const caseActivityService = {
  async listByCase(caseId: number): Promise<CaseActivity[]> {
    const response = await api.get(`/cases/${caseId}/activities`);
    return response.data.data || [];
  },

  async create(caseId: number, data: CreateActivityDto): Promise<CaseActivity> {
    const response = await api.post(`/cases/${caseId}/activities`, data);
    return response.data.data;
  },

  async update(id: number, data: Partial<CreateActivityDto>): Promise<CaseActivity> {
    const response = await api.patch(`/cases/activities/${id}`, data);
    return response.data.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/cases/activities/${id}`);
  }
};

export default caseActivityService;
